"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _react = _interopRequireDefault(require("react"));

var _Theme = _interopRequireDefault(require("../../assets/Theme9.css"));

var _Arrow = _interopRequireDefault(require("./Arrow3"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _panoMarquee = _interopRequireDefault(require("pano-marquee"));

var _payIcon = _interopRequireDefault(require("../../assets/payIcon.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var cx = _bind["default"].bind(_Theme["default"]);

var Menu = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Menu, _React$PureComponent);

  function Menu() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Menu.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        item = _this$props.item,
        leftLevel = _this$props.leftLevel,
        onClick = _this$props.onClick,
        selected = _this$props.selected,
        isShow = _this$props.isShow,
        style = _this$props.style,
        onMouseOut = _this$props.onMouseOut,
        onMouseOver = _this$props.onMouseOver,
        ui = _this$props.ui,
        level = _this$props.level,
        payScenes = _this$props.payScenes;
    var isSelected = !item.children && selected === item.id;

    var styleWp = _extends({
      paddingLeft: 15 + leftLevel * 20
    }, style);

    if (isSelected) {
      styleWp.backgroundColor = ui.btnActiveColor;
      styleWp.color = ui.fontAvtiveColor;
    }

    var isPay = payScenes.indexOf(item.id) >= 0;
    var baseWidth = document.body.clientWidth < 1024 ? 220 : 270;
    var marqueeWidth = baseWidth - leftLevel * 20;

    if (item.children) {
      marqueeWidth -= 21;
    }

    if (isPay) {
      marqueeWidth -= 21;
    }

    return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
      onMouseOut: onMouseOut,
      onMouseOver: onMouseOver,
      onClick: onClick,
      style: styleWp,
      vertical: "center",
      className: cx("MenuTheme9MenuItem", {
        selected: !item.children && selected === item.id,
        MenuTheme9Level0: level == 0
      })
    }, item.children ? /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
      fill: styleWp.color,
      position: isShow ? "down" : "right",
      className: cx("MenuTheme9Arrow")
    }) : null, /*#__PURE__*/_react["default"].createElement(_panoMarquee["default"], {
      disable: selected !== item.id,
      color: styleWp.color,
      disableColor: styleWp.color,
      maxWidth: marqueeWidth,
      fontSize: 14,
      text: item.name
    }), isPay ? /*#__PURE__*/_react["default"].createElement("img", {
      alt: "",
      src: _payIcon["default"],
      className: cx("MenuTheme9PayIcon")
    }) : null);
  };

  return Menu;
}(_react["default"].PureComponent);

var _default = Menu;
exports["default"] = _default;
module.exports = exports.default;